import React from "react";
import {DISPETCHER_COLOR} from "../GameStyleUI";
import {GetBrigadeCost} from "../../../gameplay/model/Balance";
import CardWithCost from "../GeneralCards/CardWithCost";
import AddRemoveButtons from "../AddRemoveButtons";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";

export default class InvestDispetcherCard extends React.Component {

  addBrigades(diff) {
    let state = this.props.parent.state;
    state.runtimeData.dispetcher.brigades = diff;
    this.props.parent.setState(state);
  }

  initDispetcherCard(dispetcher) {
    let styleContainer = {
      padding: "4px",
      display: "flex",
      justifyContent: "space-between"
    }
    let cards = [];
    let colors = DISPETCHER_COLOR;
    let cost = GetBrigadeCost(true);
    const cash = this.props.parent.getAvailableCash();

    let state = this.props.parent.state;
    let brigades = state.runtimeData.dispetcher.brigades;
    const isCanBuy = !this.props.disabled && cost <= cash;
    let isCanSell = !this.props.disabled && cost <= cash;

    if (dispetcher.brigades > 0) {
      if (brigades <= 0) {
        isCanSell = isCanSell && dispetcher.brigades + brigades > 0;
      }
    }

    cards.push(
      <div key={`invest-dispetcher-card-1`}>
        <CardWithCost cost={cost} colors={colors} title={"Диспетчерские бригады"} headerHeight={36} height={40}
                      width={128}/>
        <AddRemoveButtons
          colors={colors}
          width={128}
          disabled={this.props.disabled}
          value={dispetcher.brigades}
          currentRuntime={brigades}
          onValueChanged={this.addBrigades.bind(this)}
          isCanBuy={isCanBuy}
          isCanSell={isCanSell}
        />
      </div>);

    return <div style={styleContainer}>{cards}</div>;
  }

  render() {
    let dispetcher = this.props.dispetcher;
    let colors = DISPETCHER_COLOR;
    return <div>
      <GameWindowHeader
        width={138}
        height={30}
        title={"Диспетчерская"}
        colorStart={colors[0]}
        colorEnd={colors[1]}
        fontSize={12}
        lineHeight={10}
        positionTop={10}
        positionLeft={5}
      />
      <GameWindowBg width={138} height={105} color={"#F2F2F2"} value={this.initDispetcherCard(dispetcher)}/>
    </div>
  }
}
